/**
 * Created by Administrador on 24/04/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('taxpayerService',taxpayerService);

    taxpayerService.$inject = ['$http', 'CONFIG','messageService'];

    function taxpayerService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FINANCE + '/' + CONFIG.API + '/taxpayers';

        var service = {
            getTaxpayers: getTaxpayers,
            getPageTaxpayers: getPageTaxpayers,
            getTaxpayer: getTaxpayer,
            saveTaxpayer: saveTaxpayer,
            updateTaxpayer: updateTaxpayer,
            deleteTaxpayer: deleteTaxpayer
        };

        return service;

        function getTaxpayers(){
            return $http.get(urlBase)
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.taxpayers : [];
                }, function(){
                    messageService.findAllError('');
                });
        }

        function getPageTaxpayers(page, size){
            return $http.get(urlBase + "/" + 'page?page=' + page + '&size=' + size)
                .then(function(response){
                    return response;
                })
                .catch(function(){
                    messageService.findAllError('')
                });
        }

        function getTaxpayer(id){
            return $http.get(urlBase + "/" + id)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findAllError('taxpayers');
                });
        }

        function saveTaxpayer(taxpayer){
            return $http.post(urlBase, taxpayer)
                .then(function(){
                    messageService.register('taxpayers');
                }, function(){
                    messageService.registerError('taxpayers');
                });
        }

        function updateTaxpayer(taxpayer, id){
            return $http.put(urlBase + "/" + id, taxpayer)
                .then(function(){
                    messageService.registerUpdate('taxpayers');
                }, function(){
                    messageService.registerUpdateError('taxpayers');
                });
        }

        function deleteTaxpayer(id){
            return $http.delete(urlBase + "/" + id)
                .then(function(){
                    messageService.registerDelete('taxpayers');
                }, function(error){
                    if(error.data.message.indexOf('asociación')> -1 || error.data.message.indexOf('asociacion') > -1
                        || error.data.message.indexOf('association') > -1 || error.data.message.indexOf('associated') > -1){
                        messageService.registerDeleteGeneralError('taxpayers','air.taxpayer.associatedEconomicActivities');
                    }else{
                        messageService.registerDeleteError('taxpayers');
                    }
                })
        }
    }
})();
